import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { api } from "../api";
import { useMember } from "../MemberContext";
import { Brand } from "../TrainingShell";
import { H2, Overline } from "../ui";

export const AuthLayout = ({ children, title, overline }) => (
  <div className="min-h-[100dvh] bg-[#0A0A0A] text-white font-['Outfit'] grid lg:grid-cols-2">
    <div className="hidden lg:block relative">
      <img src="https://images.unsplash.com/photo-1560272564-c83b66b1ad12?w=1400&q=80&fm=jpg" alt="" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#0A0A0A]" />
    </div>
    <div className="px-6 sm:px-12 py-10 flex flex-col">
      <Brand />
      <div className="flex-1 flex flex-col justify-center max-w-md w-full py-10">
        <Overline className="mb-3">{overline}</Overline>
        <H2 className="mb-8">{title}</H2>
        {children}
      </div>
    </div>
  </div>
);

export const inputCls = "h-12 bg-transparent border-white/15 text-white focus-visible:ring-[#c1ff72] rounded-none";
export const btnCls = "w-full h-12 bg-[#c1ff72] text-black font-bold uppercase tracking-wider hover:bg-[#a8eb54] disabled:opacity-50 transition-colors active:scale-[0.98]";

function Forgot({ onBack }) {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try { await api("/auth/forgot-password", { method: "POST", body: { email } }); setSent(true); } catch (err) { toast.error(err.message); }
  };
  if (sent) return <p className="text-[#A1A1AA]" data-testid="forgot-sent">Falls ein Konto mit dieser E-Mail existiert, haben wir dir einen Link geschickt. <button className="text-[#c1ff72] underline" onClick={onBack}>Zurück zur Anmeldung</button></p>;
  return (
    <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
      <div><Label>E-Mail</Label><Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={`${inputCls} mt-2`} data-testid="forgot-email" /></div>
      <button className={btnCls} data-testid="forgot-submit">Link senden</button>
      <button type="button" onClick={onBack} className="text-sm text-[#71717A] hover:text-white" data-testid="forgot-back">Zurück</button>
    </form>
  );
}

export default function Login() {
  const { setMember } = useMember();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [forgot, setForgot] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const d = await api("/auth/login", { method: "POST", body: { email, password: pw } });
      setMember(d.member);
      const next = params.get("next");
      nav(next && next.startsWith("/training") ? next : "/training/start");
    } catch (er) { setErr(er.message); }
    setBusy(false);
  };
  return (
    <AuthLayout overline="Willkommen zurück" title={forgot ? "Passwort vergessen" : "Anmelden"}>
      {forgot ? <Forgot onBack={() => setForgot(false)} /> : (
        <form onSubmit={submit} className="space-y-5" data-testid="login-form">
          <div><Label>E-Mail</Label><Input type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={`${inputCls} mt-2`} data-testid="login-email" /></div>
          <div><Label>Passwort</Label><Input type="password" autoComplete="current-password" required value={pw} onChange={(e) => setPw(e.target.value)} className={`${inputCls} mt-2`} data-testid="login-password" /></div>
          {err && <p className="text-sm text-red-400" data-testid="login-error">{err}</p>}
          {err.includes("Eltern") && <button type="button" data-testid="login-parent-resend" className="text-sm text-[#c1ff72] underline"
            onClick={() => api("/auth/parent-resend", { method: "POST", body: { email } }).then((d) => toast.success(d.message)).catch((x) => toast.error(x.message))}>E-Mail an Eltern erneut senden</button>}
          <button disabled={busy} className={btnCls} data-testid="login-submit">{busy ? "…" : "Anmelden"}</button>
          <div className="flex justify-between text-sm">
            <button type="button" onClick={() => setForgot(true)} className="text-[#71717A] hover:text-white" data-testid="login-forgot">Passwort vergessen?</button>
            <Link to="/training/registrieren" className="text-[#c1ff72]" data-testid="login-to-register">Konto erstellen</Link>
          </div>
        </form>
      )}
    </AuthLayout>
  );
}
